var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"oct-chip-set",attrs:{"role":"grid"}},_vm._l((_vm.items),function(item,i){return _c('span',{key:i,staticClass:"oct-chip-set__item"},[_vm._t("chip",null,{"item":item})],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }